var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgBluePenguinUphold = function SvgBluePenguinUphold(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 121 40",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "bluePenguinUphold_svg__mask0_5368_110940",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120.62,
    height: 40,
    fill: "url(#bluePenguinUphold_svg__pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bluePenguinUphold_svg__mask0_5368_110940)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.62,
    height: 40,
    fill: "url(#bluePenguinUphold_svg__paint0_linear_5368_110940)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "bluePenguinUphold_svg__pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bluePenguinUphold_svg__image0_5368_110940",
    transform: "scale(0.00257069 0.00775194)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bluePenguinUphold_svg__paint0_linear_5368_110940",
    x1: 0,
    y1: 20,
    x2: 120.62,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#05A1C9"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBluePenguinUphold);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "static/bluePenguinUphold.f80e9e32.svg";